'use strict';

function getParameterByName(name) {
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
		results = regex.exec(location.search);
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

jQuery(function ($) {

	var $window = $(window);

	window.codecrewAdditional = {
		init: function () {
			this.updateHistory();
			this.newsletterForm();
			this.recipesLoadMore();
			this.ExpandAllButton();
			this.updateNotifyButton();

		},
		updateHistory: function () {

			function getVariantFromOptions() {
				let variantArr = []
				$(".product-form select").map(function (i, el) {
					var variant = {value: $(el).val(), index: $(el).data('index')};
					variantArr.push(variant)
				});
				return variantArr;
			}

			function updateHistoryState(variant) {
				if (!history.replaceState || !variant) {
					return;
				}

				var newurl =
					window.location.protocol +
					'//' +
					window.location.host +
					window.location.pathname +
					'?variant=' +
					variant.id;

				window.history.replaceState({path: newurl}, '', newurl);
			}

			$('.product-form select').on('change', function () {
				var selectedValues = getVariantFromOptions();
				var variants = window.product.variants;


				// Search for product variants based on what was selected in the dropdowns
				var found = _.find(variants, function (variant) {
					return selectedValues.every(function (values) {
						return _.isEqual(variant[values.index], values.value);
					});
				});

				updateHistoryState(found)
				$('#variant-id').val(found.id)

				// Update the price of the product in dependence of which variant is selected
				$("#ProductPrice").text("$" + (found.price / 100).toFixed(2));
              
				if (found.compare_at_price == 0 || found.compare_at_price == null) {
					$("#comparePrice").text('');
					$("#ProductPrice").removeClass("red");
				} else {
					$("#comparePrice").text("$" + (found.compare_at_price / 100).toFixed(2));
					$("#ProductPrice").addClass("red");
				}
			});

			// Add the "Out of Stock" box if the selected option has quantity=0
			$('.product-form select').on('change', function () {
				var quantity = $(this).find(':selected').data('quantity');
				var outofstock = $(".product-info .outofstock");

				if ( quantity == 0 ) {
					outofstock.css("display", "block");
				} else {
					outofstock.css("display", "none");
				}
			});
		},

		newsletterForm: function () {
			var captchaPage = window.location.pathname === '/challenge';
			var subscribedPage = getParameterByName('customer_posted');
          var subscribedPage2 = getParameterByName('form_type') === 'customer';

			if (captchaPage) $window.scrollTop(0);

			if (subscribedPage || subscribedPage2) {
				var confirmation = $('.subscribe-confirmation');

				confirmation.fadeIn();

				setTimeout(function() {
					confirmation.fadeOut();
				}, 4000);

				$('.subscribe-confirmation-close').on('click', function() {
					confirmation.fadeOut();
				});
			}

			/*$('.subscribe-form').each(function() {
				var form = $(this);
				var url = form.attr('action');
				var method = form.attr('method');

				form.on('submit', function(e) {
					e.preventDefault();

					$.ajax({
						type: method,
						//dataType: 'text',
						url: url,
						data: form.serialize(),
						beforeSend: function() {
							form.addClass('sending');
						},
						success: function (response) {

							form.removeClass('sending');

							console.log('success', response);

						},
						error: function (response) {

							form.removeClass('sending');

							console.log('error', url, response);

						}
					});
				});
			});*/

		},

		recipesLoadMore: function () {

			var initial_items = 9;
			var next_items = 6; 
			var productList = $('.js-product-items').isotope({
				layoutMode: 'packery',
				transitionDuration: '1s',
				getSortData: {
					category: '[data-category]'
				},
				packery: {
					columnWidth: '.grid-sizer'
				},
				percentPosition: true
			});

			function showNextItems(pagination) {
				var itemsMax = $('.visible_item').length;
				var itemsCount = 0;
				$('.visible_item').each(function () {
					if (itemsCount < pagination) {
						$(this).removeClass('visible_item');
						itemsCount++;
					}
				});
				if (itemsCount >= itemsMax) {
					$('.recipe_list .more-load').hide();
				}
				productList.isotope('layout');
			}
			// function that hides items when page is loaded
			function hideItems(pagination) {
				var itemsMax = $('.recipe_list .product-items li').is(":visible").length;
				var itemsCount = 0;
				$('.recipe_list .product-items li').each(function () {
					if ($(this).is(":visible")) {
						if (itemsCount >= pagination)  {
							$(this).addClass('visible_item');
						}
						itemsCount++;
					}
				});
				if (itemsCount < itemsMax || initial_items >= itemsMax) {
					$('.recipe_list .more-load').hide();
				}
				productList.isotope('layout');
			}
			// Hide Buton on filter click
			$('.recipe_list .products-filter li').on('click', function (e) {
				var categoryCount = 0;
				var category = $(this).data('category');
				var c = category.includes('all');

				$('.visible_item').removeClass('visible_item');
				if ( c != true) {
					$('.recipe_list .product-items li').each(function () {
						var category2 = $(this).data('category');
						var n = category2.includes(category);
						if ( n == true) {
							categoryCount++;
						}
					});
					if (categoryCount < initial_items) {
						$('.recipe_list .more-load').hide();
					} else {
						$('.recipe_list .more-load').show();
						setTimeout(function(){
							hideItems(initial_items);
						}, 1400);
					}
					categoryCount = 0;
				} else {
					setTimeout(function(){
						hideItems(initial_items);
						$('.recipe_list .more-load').show();
					}, 200);
				}

			});

			$('.recipe_list .products-list .more-load a').on('click', function (e) {
				e.preventDefault();
				showNextItems(next_items);
			});
			hideItems(initial_items);

		},

		ExpandAllButton: function () {
			$('.expandall').click(function expand() {

				if ($(this).data("lastState") === null || $(this).data("lastState") === 0) {
					$('.accordion .collapse.show').collapse('hide');
					$(this).data("lastState",1);
					$(this).find("span").text("Expand All");
					$(this).find("i").removeClass('fa-minus').addClass('fa-plus');
				}
				else {

					$('.accordion .panel-collapse').removeData('bs.collapse')
					.collapse({parent:'', toggle:false})
					.collapse('show')
					.removeData('bs.collapse')
					.collapse({parent:'.accordion', toggle:false});

					$(this).data("lastState",0);
					$(this).find("span").text("Close All");
					$(this).find("i").removeClass('fa-plus').addClass('fa-minus');

				}

			});
			$('.accordion .panel-collapse').on('shown.bs.collapse', function () {
				$(this).parent(".accordion-item").find(".accordion-title a").addClass('shown');
			});
			$('.accordion .panel-collapse').on('hidden.bs.collapse', function () {
				$(this).parent(".accordion-item").find(".accordion-title a").removeClass('shown');
			});
			//expand();
		},

		updateNotifyButton: function () {
			var generalq = 0;
			$(window).on('load', function () {
				$('.product-option option').each(function() {
					if ($(this).attr('data-quantity')) {
						var eachq = parseInt($( this ).attr('data-quantity'));
						generalq += eachq
					}
				});
				
				if (generalq > 0) {
					$('.notify_btn').css('display', 'none');
					$('.AddToCart').css('display', 'block');
				}
			})

			$('.product-option').on('change', function() {
				var currentq = $(this).find('option:selected').attr('data-quantity');

				if (currentq == 0) {
					$('.notify_btn').css('display', 'inline-block');
					$('.AddToCart').css('display', 'none');
				} else {
					$('.AddToCart').css('display', 'block');
				}
			})
		}
	

	};

	codecrewAdditional.init();
});



window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

	/**
	 * Return an object from an array of objects that matches the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	findInstance: function(array, key, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i][key] === value) {
				return array[i];
			}
		}
	},

	/**
	 * Remove an object from an array of objects by matching the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	removeInstance: function(array, key, value) {
		var i = array.length;
		while(i--) {
			if (array[i][key] === value) {
				array.splice(i, 1);
				break;
			}
		}

		return array;
	},

	/**
	 * _.compact from lodash
	 * Remove empty/false items from array
	 * Source: https://github.com/lodash/lodash/blob/master/compact.js
	 *
	 * @param {array} array
	 */
	compact: function(array) {
		var index = -1;
		var length = array == null ? 0 : array.length;
		var resIndex = 0;
		var result = [];

		while (++index < length) {
			var value = array[index];
			if (value) {
				result[resIndex++] = value;
			}
		}
		return result;
	},

	/**
	 * _.defaultTo from lodash
	 * Checks `value` to determine whether a default value should be returned in
	 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	 * or `undefined`.
	 * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
	 *
	 * @param {*} value - Value to check
	 * @param {*} defaultValue - Default value
	 * @returns {*} - Returns the resolved value
	 */
	defaultTo: function(value, defaultValue) {
		return (value == null || value !== value) ? defaultValue : value;
	},

	/**
	 * Constructs an object of key / value pairs out of the parameters of the query string
	 *
	 * @return {Object}
	 */
	getQueryParams: function() {
		var queryString = location.search && location.search.substr(1) || '';
		var queryParams = {};

		queryString
			.split('&')
			.filter(function (element) {
				return element.length;
			})
			.forEach(function (paramValue) {
				var splitted = paramValue.split('=');

				if (splitted.length > 1) {
					queryParams[splitted[0]] = splitted[1];
				} else {
					queryParams[splitted[0]] = true;
				}
			});

		return queryParams;
	},

	/**
	 * Returns empty string or query string with '?' prefix
	 *
	 * @return (string)
	 */
	getQueryString: function() {
		var queryString = location.search && location.search.substr(1) || '';

		// Add the '?' prefix if there is an actual query
		if(queryString.length){
			queryString = '?' + queryString;
		}

		return queryString;
	},

	/**
	 * Constructs a version of the current URL with the passed in key value pair as part of the query string
	 *
	 * @param {String} key
	 * @param {String} value
	 * @param {String} uri - optional, defaults to window.location.href
	 * @return {String}
	 */
	getUrlWithUpdatedQueryStringParameter: function(key, value, uri) {
		uri = uri || window.location.href;

		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";

		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return uri + separator + key + "=" + value;
		}
	},

	/**
	 * Constructs a version of the current URL with the passed in parameter key and associated value removed
	 *
	 * @param {String} key
	 * @return {String}
	 */
	getUrlWithRemovedQueryStringParameter: function(parameterKeyToRemove, uri) {
		uri = uri || window.location.href;

		var rtn = uri.split("?")[0],
			param,
			params_arr = [],
			queryString = (uri.indexOf("?") !== -1) ? uri.split("?")[1] : "";

		if (queryString !== "") {
			params_arr = queryString.split("&");
			for (var i = params_arr.length - 1; i >= 0; i -= 1) {
				param = params_arr[i].split("=")[0];
				if (param === parameterKeyToRemove) {
					params_arr.splice(i, 1);
				}
			}
			if (params_arr.length > 0) {
				rtn = rtn + "?" + params_arr.join("&");
			}
		}

		return rtn;
	},

	/**
	 * Check if we're running the theme inside the theme editor
	 *
	 * @return {bool}
	 */
	isThemeEditor: function() {
		return location.href.match(/myshopify.com/) !== null && location.href.match(/theme_id/) !== null;
	},

	/**
	 * Get the name of the correct 'transitionend' event for the browser we're in
	 *
	 * @return {string}
	 */
	whichTransitionEnd: function() {
		var t;
		var el = document.createElement('fakeelement');
		var transitions = {
			'transition':'transitionend',
			'OTransition':'oTransitionEnd',
			'MozTransition':'transitionend',
			'WebkitTransition':'webkitTransitionEnd'
		};

		for(t in transitions){
			if( el.style[t] !== undefined ){
				return transitions[t];
			}
		}
	},

	/**
	 * Adds user agent classes to the document to target specific browsers
	 *
	 */
	userAgentBodyClass: function() {
		var ua = navigator.userAgent,
			d = document.documentElement,
			classes = d.className,
			matches;

		// Detect iOS (needed to disable zoom on form elements)
		// http://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
		if ( /iPad|iPhone|iPod/.test(ua) && !window.MSStream ) {
			classes += ' ua-ios';

			// Add class for version of iOS
			matches = ua.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/);
			if ( matches ) {
				classes += ' ua-ios-' + matches[1];// e.g. ua-ios-7_0_2
			}

			// Add class for Twitter app
			if ( /Twitter/.test(ua) ) {
				classes += ' ua-ios-twitter';
			}

			// Add class for Chrome browser
			if ( /CriOS/.test(ua) ) {
				classes += ' ua-ios-chrome';
			}
		}

		// Detect Android (needed to disable print links on old devices)
		// http://www.ainixon.me/how-to-detect-android-version-using-js/
		if ( /Android/.test(ua) ) {
			matches = ua.match(/Android\s([0-9\.]*)/);
			classes += matches ? ' ua-aos ua-aos-' + matches[1].replace(/\./g,'_') : ' ua-aos';
		}

		// Detect webOS (needed to disable optimizeLegibility)
		if ( /webOS|hpwOS/.test(ua) ) {
			classes += ' ua-webos';
		}

		// Detect Samsung Internet browser
		if ( /SamsungBrowser/.test(ua) ) {
			classes += ' ua-samsung';
		}

		d.className = classes;
	},

	/**
	 * Generates a 32 bit integer from a string
	 * Reference - https://stackoverflow.com/a/7616484
	 *
	 * @param {string}
	 * @return {int}
	 */
	hashFromString: function(string) {
		var hash = 0, i, chr;
		if (string.length === 0) return hash;
		for (i = 0; i < string.length; i++) {
			chr   = string.charCodeAt(i);
			hash  = ((hash << 5) - hash) + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	},

	chosenSelects: function($container) {
		var $selects = $container ? $('select.form-control', $container) : $('select.form-control');
		//$selects.not('[data-no-chosen]').chosen();
	},

	/**
	 * Browser cookies are required to use the cart. This function checks if
	 * cookies are enabled in the browser.
	 */
	cookiesEnabled: function() {
		var cookieEnabled = navigator.cookieEnabled;

		if (!cookieEnabled){
			document.cookie = 'testcookie';
			cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
		}
		return cookieEnabled;
	},

	/**
	 * Pluralizes the unit for the nuber passed in.
	 * Usage mirrors the Shopify "pluralize" string filter
	 *
	 * @param {Number} number
	 * @param {String} singular
	 * @param {String} plural
	 * @return {String}
	 */
	pluralize: function(number, singular, plural)  {
		var output = '';

		number = parseInt(number);

		if(number == 1) {
			output = singular;
		}
		else {
			output = plural;
			if (typeof plural == "undefined") {
				output = singular + 's'; // last resort, turn singular into a plural
			}
		}
		return output;
	},

	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * Example: limit the output of this computation to between 0 and 255
	 * clamp(x, 0, 255)
	 *
	 * @param {Number} number Number to clamp
	 * @param {Number} min The lower boundary of the output range
	 * @param {Number} max The upper boundary of the output range
	 * @returns A number in the range [min, max]
	 * @type Number
	 */
	clamp: function(number, min, max) {
		return Math.min(Math.max(number, min), max);
	},

	/**
	 * Returns viewport width consistent with @media (width)
	 * Source:
	 * https://stackoverflow.com/questions/1248081/get-the-browser-viewport-dimensions-with-javascript
	 */
	getViewportWidth: function() {
		return Math.max(
			document.documentElement.clientWidth,
			window.innerWidth || 0
		);
	},

	/**
	 * Returns viewport height conssitent with @media (height)
	 * Source:
	 * https://stackoverflow.com/questions/1248081/get-the-browser-viewport-dimensions-with-javascript
	 */
	getViewportHeight: function() {
		return Math.max(
			document.documentElement.clientHeight,
			window.innerHeight || 0
		);
	},

	/**
	 * Checks if total children width is larger than parent width
	 */
	childrenLargerThanParent: function($parent, $children) {
		if (!$parent || !$parent.length || !$children || !$children.length) {
			return false;
		}
		var parentWidth = $parent[0].offsetWidth,
			totalChildrenWidth = 0;

		$children.each(function() {
			totalChildrenWidth += $(this)[0].offsetWidth;
		});

		return parentWidth < totalChildrenWidth;
	},

	/**
	 * In JS <negative int> % <positive int> yields a negative number
	 * Which is not consistent with mathematical modulo operation
	 * When -2 mod 7 = 5
	 *
	 * This function is coherent with mathematical modulo
	 */
	naturalMod: function (x, n) {
		return (x % n + n) % n;
	},

	/**
	 * Returns true is element is whithin viewport
	 * @param {*} $el
	 */
	elementIsWithinViewport: function ($el) {
		var elementTop = $el.offset().top;
		var elementBottom = elementTop + $el.outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	}
};

/**
 * Constants
 * -----------------------------------------------------------------------------
 * A collection of useful constants shared by different modules
 *
 * @namespace constants
 */

slate.constants = {
	cart: {
		ajax: {
			UPDATE: 'cart.ajax.UPDATE',
			REMOVE: 'cart.ajax.REMOVE'
		}
	},
	productDetailForm: {
		READY: 'ready.productDetailForm'
	}

};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {

	/**
	 * Wrap tables in a container div to make them scrollable when needed
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
	 * @param {string} options.tableWrapperClass - table wrapper class name
	 */
	wrapTables: function(options) {
		var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

		options.$tables.addClass('table');
		options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
	},

	/**
	 * Wrap iframes in a container div to make them responsive
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
	 * @param {string} options.iframeWrapperClass - class name used on the wrapping div
	 */
	wrapIframe: function(options) {
		var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

		options.$iframes.each(function() {
			// Add wrapper to make video responsive
			$(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

			// Re-set the src attribute on each iframe after page load
			// for Chrome's "incorrect iFrame content on 'back'" bug.
			// https://code.google.com/p/chromium/issues/detail?id=395791
			// Need to specifically target video and admin bar
			this.src = this.src;
		});
	}
};

slate.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	$(document)
		.on('shopify:section:load', this._onSectionLoad.bind(this))
		.on('shopify:section:unload', this._onSectionUnload.bind(this))
		.on('shopify:section:select', this._onSelect.bind(this))
		.on('shopify:section:deselect', this._onDeselect.bind(this))
		.on('shopify:section:reorder', this._onReorder.bind(this))
		.on('shopify:block:select', this._onBlockSelect.bind(this))
		.on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
	_createInstance: function(container, constructor) {
		var $container = $(container);
		var id = $container.attr('data-section-id');
		var type = $container.attr('data-section-type');

		constructor = constructor || this.constructors[type];

		if (typeof constructor === 'undefined') {
			return;
		}

		var instance = $.extend(new constructor(container), {
			id: id,
			type: type,
			container: container
		});

		this.instances.push(instance);
	},

	_onSectionLoad: function(evt) {
		var container = $('[data-section-id]', evt.target)[0];
		if (container) {
			this._createInstance(container);
		}
	},

	_onSectionUnload: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (!instance) {
			return;
		}

		if (typeof instance.onUnload === 'function') {
			instance.onUnload(evt);
		}

		this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
	},

	_onSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onSelect === 'function') {
			instance.onSelect(evt);
		}
	},

	_onDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onDeselect === 'function') {
			instance.onDeselect(evt);
		}
	},

	_onReorder: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onReorder === 'function') {
			instance.onReorder(evt);
		}
	},

	_onBlockSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onBlockSelect === 'function') {
			instance.onBlockSelect(evt);
		}
	},

	_onBlockDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onBlockDeselect === 'function') {
			instance.onBlockDeselect(evt);
		}
	},

	register: function(type, constructor) {
		this.constructors[type] = constructor;

		$('[data-section-type=' + type + ']').each(function(index, container) {
			this._createInstance(container, constructor);
		}.bind(this));
	}
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
	var moneyFormat = '${{amount}}';

	/**
	 * Format money values based on your shop currency settings
	 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
	 * or 3.00 dollars
	 * @param  {String} format - shop money_format setting
	 * @return {String} value - formatted value
	 */
	function formatMoney(cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || moneyFormat);

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = slate.utils.defaultTo(precision, 2);
			thousands = slate.utils.defaultTo(thousands, ',');
			decimal = slate.utils.defaultTo(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.');
			var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
			var centsAmount = parts[1] ? (decimal + parts[1]) : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_space_separator':
				value = formatWithDelimiters(cents, 2, ' ', '.');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, ',', '.');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = formatWithDelimiters(cents, 0, ' ');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	return {
		formatMoney: formatMoney
	};
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

	/**
	 * Preloads an image in memory and uses the browsers cache to store it until needed.
	 *
	 * @param {Array} images - A list of image urls
	 * @param {String} size - A shopify image size attribute
	 */
	function preload(images, size) {
		if (typeof images === 'string') {
			images = [images];
		}

		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}

	/**
	 * Loads and caches an image in the browsers cache.
	 * @param {string} path - An image url
	 */
	function loadImage(path) {
		new Image().src = path;
	}

	/**
	 * Find the Shopify image attribute size
	 *
	 * @param {string} src
	 * @returns {null}
	 */
	function imageSize(src) {
		var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

		if (match) {
			return match[1];
		} else {
			return null;
		}
	}

	/**
	 * Adds a Shopify size attribute to a URL
	 *
	 * @param src
	 * @param size
	 * @returns {*}
	 */
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === 'master') {
			return this.removeProtocol(src);
		}

		var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

		if (match) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else {
			return null;
		}
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, '');
	}

	return {
		preload: preload,
		loadImage: loadImage,
		imageSize: imageSize,
		getSizedImageUrl: getSizedImageUrl,
		removeProtocol: removeProtocol
	};
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

	/**
	 * Variant constructor
	 *
	 * @param {object} options - Settings from `product.js`
	 */
	function Variants(options) {
		this.$container = options.$container;
		this.product = options.product;
		this.singleOptionSelector = options.singleOptionSelector;
		this.originalSelectorId = options.originalSelectorId;
		this.enableHistoryState = options.enableHistoryState;
		this.currentVariant = this._getVariantFromOptions();

		$(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
	}

	Variants.prototype = $.extend({}, Variants.prototype, {

		/**
		 * Get the currently selected options from add-to-cart form. Works with all
		 * form input elements.
		 *
		 * @return {array} options - Values of currently selected variants
		 */
		_getCurrentOptions: function() {
			var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
				var $element = $(element);
				var type = $element.attr('type');
				var currentOption = {};

				if (type === 'radio' || type === 'checkbox') {
					if ($element[0].checked) {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');

						return currentOption;
					} else {
						return false;
					}
				} else {
					currentOption.value = $element.val();
					currentOption.index = $element.data('index');

					return currentOption;
				}
			});

			// remove any unchecked input values if using radio buttons or checkboxes
			currentOptions = slate.utils.compact(currentOptions);

			return currentOptions;
		},

		/**
		 * Find variant based on selected values.
		 *
		 * @param  {array} selectedValues - Values of variant inputs
		 * @return {object || undefined} found - Variant object from product.variants
		 */
		_getVariantFromOptions: function() {
			var selectedValues = this._getCurrentOptions();
			var variants = this.product.variants;
			var found = false;

			variants.forEach(function(variant) {
				var satisfied = true;

				selectedValues.forEach(function(option) {
					if (satisfied) {
						satisfied = (option.value === variant[option.index]);
					}
				});

				if (satisfied) {
					found = variant;
				}
			});

			return found || null;
		},

		/**
		 * Event handler for when a variant input changes.
		 */
		_onSelectChange: function() {
			var variant = this._getVariantFromOptions();

			// Bug in recharge, needs a click event to update base price, this will
			// allow us to have an accurate variant price when updating the total.
			$(['data-product-price']).trigger('click')

			var that = this;

			setTimeout(function() {
				that.$container.trigger({
					type: 'variantChange',
					variant: variant
				});
			}, 100);

			if (!variant) {
				return;
			}

			this._updateMasterSelect(variant);
			this._updateImages(variant);
			this._updatePrice(variant);
			this.currentVariant = variant;

			if (this.enableHistoryState) {
				this._updateHistoryState(variant);
			}
		},

		/**
		 * Trigger event when variant image changes
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event}  variantImageChange
		 */
		_updateImages: function(variant) {
			var variantImage = variant.featured_image || {};
			var currentVariantImage = this.currentVariant.featured_image || {};

			if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
				return;
			}

			this.$container.trigger({
				type: 'variantImageChange',
				variant: variant
			});
		},

		/**
		 * Trigger event when variant price changes.
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event} variantPriceChange
		 */
		_updatePrice: function(variant) {
			if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
				return;
			}

			this.$container.trigger({
				type: 'variantPriceChange',
				variant: variant
			});
		},

		/**
		 * Update history state for product deeplinking
		 *
		 * @param  {variant} variant - Currently selected variant
		 * @return {k}         [description]
		 */
		_updateHistoryState: function(variant) {
			if (!history.replaceState || !variant) {
				return;
			}

			var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
			window.history.replaceState({path: newurl}, '', newurl);
		},

		/**
		 * Update hidden master select of variant change
		 *
		 * @param  {variant} variant - Currently selected variant
		 */
		_updateMasterSelect: function(variant) {
			$(this.originalSelectorId, this.$container)[0].value = variant.id;
		}
	});

	return Variants;
})();

/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 *
 * This is a bare-bones but completely usable implementation of an AJAX enabled cart
 *
 * Usage: slate.AjaxCart.init(options);
 *
 * See the following list of stubbed / incomplete methods that need to be filled in
 *
 *   - AjaxCart.onOpenClick
 *   - AjaxCart.onCloseClick
 *   - AjaxCart.open
 *   - AjaxCart.close
 *   - AjaxCart.onItemAddFail
 *   - AjaxCart.buildCart
 *
 */

(function($, Handlebars, slate) {

	if (typeof ShopifyAPI === "undefined") var ShopifyAPI = {};

	/*============================================================================
	  API Functions
	==============================================================================*/

	/**
	 * AJAX submit an 'add to cart' form
	 *
	 * @param {jQuery} $form - jQuery instance of the form
	 * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
	 */
	ShopifyAPI.addItemFromForm = function($form) {
		var promise = $.Deferred();

		$.ajax({
			type: 'post',
			dataType: 'json',
			url: '/cart/add.js',
			data: $form.serialize(),
			success: function () {
				ShopifyAPI.getCart().then(function (data) {
					promise.resolve(data);
				});
			},
			error: function (resp) {
				promise.reject({
					message: 'The quantity you entered is not available.'
				});

				alert(resp.responseJSON.description);
			}
		});

		return promise;
	};

	/**
	 * Retrieve a JSON respresentation of the users cart
	 *
	 * @return {Promise} - JSON cart
	 */
	ShopifyAPI.getCart = function() {

		var promise = $.Deferred();

		//var url = slate.utils.isThemeEditor() ? "/cart.js" : "/cart?view=json";
		var url = "/cart.js";

		$.ajax({
			type: 'get',
			dataType: 'json',
			url: url,
			success: function (data) {
				//var cart = JSON.parse(data);
				promise.resolve(data);
			},
			error: function () {
				promise.reject({
					message: 'Could not retrieve cart items'
				});
			}
		});

		return promise;
	};


	/**
	 * Retrieve a JSON respresentation of the users cart
	 *
	 * @return {Promise} - JSON cart
	 */
	ShopifyAPI.getProduct = function(handle) {
		return $.getJSON('/products/' + handle + '.js');
	};

	/**
	 * Change the quantity of an item in the users cart
	 *
	 * @param {int} variantId - Variant to be adjust
	 * @param {int} qty - New quantity of the variant
	 * @return {Promise} - JSON cart
	 */
	ShopifyAPI.changeItemQuantity = function(variantId, qty, key) {
		return $.ajax({
			type: 'post',
			dataType: 'json',
			url: '/cart/change.js',
			data: {quantity: qty, id: key!== undefined ? key : variantId}
			//data: 'quantity=' + qty + '&id=' + variantId
		});
	};


	/**
	 * Adds a product using the variant ID
	 *
	 * @param {int} variantId - Variant to be adjust
	 * @param {int} qty - New quantity of the variant
	 * @return {Promise} - JSON cart
	 */

	ShopifyAPI.addItemToCart = function(variantId, qty) {
		return $.ajax({
			type: 'post',
			dataType: 'json',
			url: '/cart/add.js',
			data: 'quantity=' + qty + '&id=' + variantId
		});
	};

	/*============================================================================
	  Ajax Shopify Add To Cart
	==============================================================================*/

	slate.AjaxCart = (function() {

		var $window = $(window);
		var $body = $('body');

		var selectors = {
			container: '[data-ajax-cart-container]',
			template: 'script[data-ajax-cart-template]',
			trigger: '[data-ajax-cart-trigger]',
			close: '[data-ajax-cart-close]',
			addForm: 'form[action^="/cart/add"]',
			addToCart: '.btn',
			addToCartText: '[data-add-to-cart-text]',
			header: '[data-ajax-cart-header]',
			body: '[data-ajax-cart-body]',
			footer: '[data-ajax-cart-footer]',
			item: '[data-ajax-item][data-id][data-qty]',
			itemRemove: '[data-ajax-cart-item-remove]',
			itemIncrement: '[data-ajax-cart-item-increment]',
			itemDecrement: '[data-ajax-cart-item-decrement]',
			itemQuantitySelect: 'select[data-ajax-cart-item-quantity]',
			itemQuantityInput: 'input[data-ajax-cart-item-quantity]',
			cartBadge: '[data-cart-badge]',
			cartBadgeCount: '[data-cart-badge-count]',
			giftProduct: '[data-gift-product]'
		};

		var classes = {
			bodyCartOpen: 'overflow-hidden',
			backdrop: 'ajax-cart-backdrop',
			backdropVisible: 'is-visible',
			cartOpen: 'is-open',
			cartBadgeHasItems: 'has-items'
		};

		$body.append('<div class="scrollbar-detect"><span></span></div>');
		var scrollBarDetect = $('.scrollbar-detect');
		var scrollBarWidth = scrollBarDetect.width() - scrollBarDetect.find('span').width();
		scrollBarDetect.remove();

		(function() {
			$body.on('click', '.js-ajax-button-minus', function(e) {
				e.preventDefault();

				var button = $(this);
				var input = button.siblings('input');
				var value = parseInt(input.val()) - 1;

				if (value < 1) return;
				if (value < 10) value = '0' + value;

				input.val(value).change();
			});

			$body.on('click', '.js-ajax-button-plus', function(e) {
				e.preventDefault();

				var button = $(this);
				var input = button.siblings('input');
				var value = parseInt(input.val()) + 1;

				if (value < 10) value = '0' + value;

				input.val(value).change();
			});
		})();

		/**
		 * AjaxCart constructor
		 *
		 * Adds an `init` method with access to private variables inside the contructor
		 */
		function AjaxCart() {
			this.name = 'ajaxCart';
			this.namespace = '.' + this.name;
			this.events = {
				RENDER:  'render'  + this.namespace,
				DESTROY: 'destroy' + this.namespace,
				SCROLL:  'scroll'  + this.namespace,
				UPDATE:  'update'  + this.namespace //  Use this as a global event to hook into whenever the cart changes
			};

			this.QUANTITY_SELECT_LIMIT = 5;

			var initialized = false;
			var settings = {
				disableAjaxCart: false
			};

			this.$el         = $(selectors.container);
			this.$backdrop   = null;
			this.stateIsOpen = null;
			this.giftProduct = $(selectors.giftProduct).length == 1 ? JSON.parse($(selectors.giftProduct).html()) : "";
			this.transitionEndEvent = slate.utils.whichTransitionEnd();

			/**
			 * Initialize the cart
			 *
			 * @param {object} options - see `settings` variable above
			 */
			this.init = function(options) {
				if(initialized) return;

				this.settings = $.extend(settings, options);

				if(!$(selectors.template).length){
					console.warn('['+this.name+'] - Handlebars template required to initialize');
					return;
				}

				this.$container      = $(selectors.container);
				this.$cartBadge      = $(selectors.cartBadge);
				this.$cartBadgeCount = $(selectors.cartBadgeCount);

				// Compile this once during initialization
				this._registerHelpers(Handlebars);
				this.template = Handlebars.compile($(selectors.template).html());

				// Add the AJAX part
				if(!this.settings.disableAjaxCart) {
					this._formOverride();
				}

				// Add event handlers here
				$body.on('click', selectors.trigger, this.onTriggerClick.bind(this));
				$body.on('click', selectors.close, this.onCloseClick.bind(this));
				$body.on('click', selectors.itemRemove, this.onItemRemoveClick.bind(this));
				$body.on('click', selectors.itemIncrement, this.onItemIncrementClick.bind(this));
				$body.on('click', selectors.itemDecrement, this.onItemDecrementClick.bind(this));
				$body.on('change', selectors.itemQuantitySelect, this.onItemQuantitySelectChange.bind(this));
				$body.on('change', selectors.itemQuantityInput, this.onItemQuantityInputChange.bind(this));
				$window.on(this.events.RENDER, this.onCartRender.bind(this));
				$window.on(this.events.DESTROY, this.onCartDestroy.bind(this));

				// Get the cart data when we initialize the instance
				this._checkCartStatus.call(this);

				initialized = true;

				return initialized;
			};

			return this;
		}

		AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

			_checkCartStatus: function () {
				var _this = this;
				// check if the cart has only one item
				ShopifyAPI.getCart().then(function (cart) {
					if (cart.items.length == 1) {
						// Check if the item is the gift product,
						// it should be present only alongside other product
						if (cart.items[0].variant_id === _this.giftProduct.variantId) {
							// If the only product in the cart is the gift, remove it.
							_this._removeGiftProduct.call(_this);
						} else {
							_this.buildCart.call(_this, cart);
						}
					} else {
						_this.buildCart.call(_this, cart);
					}
				});
			},

			/**
			 * Call this function to AJAX-ify any add to cart forms on the page
			 */
			_formOverride: function() {
				var _this = this;

				$('.product-card').find('form .btn').removeAttr('onclick');

				$body.on('click', '.product-card form .btn', function() {
					var form = $(this).closest('form');
					form.submit();
				});

				$body.on('submit', selectors.addForm, function(e) {
					e.preventDefault();

					var $submitButton = $(e.target).find(selectors.addToCart);
					var $submitButtonText = $submitButton.find(selectors.addToCartText);

					// Update the submit button text and disable the button so the user knows the form is being submitted
					$submitButton.prop('disabled', true);
					//$submitButtonText.html(theme.strings.adding);

					ShopifyAPI.addItemFromForm( $(e.target) )
						.then(function(data) {
							// Reset button state
							$submitButton.prop('disabled', false);
							//$submitButtonText.html(theme.strings.addToCart);
							_this._checkGiftProduct.call(_this, data);
						})
						.fail(function(data) {
							// Reset button state
							$submitButton.prop('disabled', false);
							//$submitButtonText.html(theme.strings.addToCart);
							_this.onItemAddFail.call(_this, data) ;
						});
				}.bind(this));
			},

			_checkGiftProduct: function (cart) {
				var _this = this;
				var hasGiftProduct = false;

				if ( _this.giftProduct != "" ) {
					//Check if the current cart has the gift product already added
					$.each(cart.items, function(index, item) {
						if (item.variant_id === _this.giftProduct.variantId) {
							hasGiftProduct = true;
						}
					});

					if (hasGiftProduct) {
						// If product exists continue the process
						_this.onItemAddSuccess.call(_this, cart);
					} else {
						// If not add the product then continue the process
						_this._addGiftProduct(_this.giftProduct.variantId);
					}
				} else {
					_this.onItemAddSuccess.call(_this, cart);
				}
			},

			_addGiftProduct: function(id) {
				var _this = this;
				ShopifyAPI.addItemToCart(id, 1).then(function () {
					ShopifyAPI.getCart().then(function (data) {
						_this.onItemAddSuccess(data);
					})
				});
			},

			_removeGiftProduct: function() {
				var _this = this;
				var id = _this.giftProduct.variantId;
				ShopifyAPI.changeItemQuantity(id, 0).then(function () {
					ShopifyAPI.getCart().then(function (data) {
						_this.buildCart.call(_this, data);
					})
				});
			},

			/**
			 * Ensure we are working with a valid number
			 *
			 * @param {int|string} qty
			 * @return {int} - Integer quantity.  Defaults to 1
			 */
			_validateQty: function(qty) {
				return (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ? qty : 1;
			},

			_getItemRowAttributes: function(el) {
				var $el = $(el);
				var $row = $el.is(selectors.item) ? $el : $el.parents(selectors.item);

				return {
					$row: $row,
					id:  $row.data('id'),
					qty: this._validateQty($row.data('qty')),
					key: $row.data('key')
				};
			},

			/**
			 * Adds helper functions to Handlebars library.
			 *
			 * @param {Handlebars} Handlebars - Global instance
			 */
			_registerHelpers: function(Handlebars) {
				var _this = this;

				Handlebars.registerHelper('qty-select', function(qty, cartItem) {
					var $output = $('<select />');
					$output.addClass('form-control form-control--outlined');
					$output.attr('data-ajax-cart-item-quantity', '');

					var limit = _this.QUANTITY_SELECT_LIMIT;
					var singularLabel;
					var pluralLabel;

					qty = parseInt(qty) || 1;

					if(cartItem && cartItem.metafields && cartItem.metafields.labels) {
						singularLabel = cartItem.metafields.labels.bulk_unit_name_singular || '';
						pluralLabel   = cartItem.metafields.labels.bulk_unit_name_plural || '';
					}

					for (var i = 1; i <= limit; i++) {
						var $option = $('<option />');
						var val = i;
						var text = i;

						text += ' ' + slate.utils.pluralize(i, singularLabel, pluralLabel);

						$option.val(val);
						$option.text(text);
						$option.attr('selected', (i == qty));

						$output.append($option);
					}

					return $output.get(0).outerHTML;
				});

				Handlebars.registerHelper('qty-input', function(qty, cartItem) {
					qty = parseInt(qty) || 1;

					var qt = qty < 10 ? '0' + qty : qty;

					var $output = $('<div class="product-amount">\n' +
						'\t\t\t\t\t\t\t\t\t<a class="button-minus js-ajax-button-minus" href="#">-</a>\n' +
						'\t\t\t\t\t\t\t\t\t<a class="button-plus js-ajax-button-plus" href="#">+</a>\n' +
						'\t\t\t\t\t\t\t\t\t<input type="text" value="' + qt + '" />\n' +
						'\t\t\t\t\t\t\t\t</div>');

					$output.find('input').attr('data-ajax-cart-item-quantity', '');

					var limit = _this.QUANTITY_SELECT_LIMIT;
					var singularLabel;
					var pluralLabel;

					return $output.get(0).outerHTML;
				});
			},

			addBackdrop: function(callback) {

				var _this = this;
				var cb    = callback || $.noop;

				if(this.stateIsOpen) {
					this.$backdrop = $(document.createElement('div'));

					this.$backdrop.addClass(classes.backdrop)
						.appendTo($body);

					this.$backdrop.one(this.transitionEndEvent, cb);
					this.$backdrop.one('click', this.close.bind(this));

					// debug this...
					setTimeout(function() {
						_this.$backdrop.addClass(classes.backdropVisible);
					}, 10);
				}
				else {
					cb();
				}
			},

			removeBackdrop: function(callback) {

				var _this = this;
				var cb    = callback || $.noop;

				if(!this.stateIsOpen && this.$backdrop) {
					this.$backdrop.one(this.transitionEndEvent, function(){
						_this.$backdrop && _this.$backdrop.remove();
						_this.$backdrop = null;
						cb();
					});

					setTimeout(function() {
						_this.$backdrop.removeClass(classes.backdropVisible);
					}, 10);
				}
				else {
					cb();
				}
			},

			/**
			 * Callback when adding an item is successful
			 *
			 * @param {Object} cart - JSON representation of the cart.
			 */
			onItemAddSuccess: function(cart){
				this.buildCart.call(this, cart);
				this.open();
				$window.trigger(slate.constants.cart.ajax.UPDATE, cart);
			},

			/**
			 * STUB - Callback when adding an item fails

			 * @param {Object} data
			 * @param {string} data.message - error message
			 */
			onItemAddFail: function(data){
				console.log('['+this.name+'] - onItemAddFail');
				console.warn('['+this.name+'] - ' + data.message);
			},

			/**
			 * Callback for when the cart HTML is rendered to the page
			 * Allows us to add event handlers for events that don't bubble
			 */
			onCartRender: function(e) {
				//slate.utils.chosenSelects(this.$container);
			},

			/**
			 * Callback for when the cart HTML is removed from the page
			 * Allows us to do cleanup on any event handlers applied post-render
			 */
			onCartDestroy: function(e) {
				// console.log('['+this.name+'] - onCartDestroy');
			},

			/**
			 * Builds the HTML for the ajax cart.
			 * Modifies the JSON cart for consumption by our handlebars template
			 *
			 * @param {object} cart - JSON representation of the cart.  See https://help.shopify.com/themes/development/getting-started/using-ajax-api#get-cart
			 * @return ??
			 */
			buildCart: function(cart) {
				var _this = this;

				// Make adjustments to the cart object contents before we pass it off to the handlebars template
				//cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
				cart.total_price = slate.Currency.formatMoney(cart.total_price);
				cart.items.map(function(item){
					item.image    = slate.Image.getSizedImageUrl(item.image, '200x');
					//item.price    = slate.Currency.formatMoney(item.price, theme.moneyFormat);
					item.price    = slate.Currency.formatMoney(item.price);

					var singleUnitQuantity;
					var singleUnitQuantityLabel;
					var singleUnitQuantityBreakdown;

					var bulkUnitQuantityLabel;
					var bulkUnitQuantityBreakdown;

					if(item.variant_title == "Default Title") {
						delete item.variant_title;
					}

					// If the product is a recharge subscription product
					if(item.properties && item.properties.shipping_interval_frequency && item.properties.shipping_interval_unit_type) {
						// Add property like "Delivery: Every 15 days"
						item.shipping_interval = "deliver every ";
						item.shipping_interval += item.properties.shipping_interval_frequency + ' ' + item.properties.shipping_interval_unit_type;
					}
					// Product isn't the hidden recharge product, but has an associated recharge product
					else if(item.metafields && item.metafields.subscriptions && item.metafields.subscriptions.subscription_id){
						item.shipping_interval = "one-time purchase";
					}

					// Add the quantity breakdown if all metafields are available
					// This is kind of a pain but we have to check for the existence of all these fields in order to output the correct text
					if(item.metafields && item.metafields.labels) {

						// Create the single unit quantity breakdown if possible
						if(item.metafields.bulk_quantity && item.metafields.bulk_quantity.quantity && item.metafields.labels.single_unit_name_singular) {
							singleUnitQuantity = item.quantity * item.metafields.bulk_quantity.quantity;
							singleUnitQuantityLabel = slate.utils.pluralize(singleUnitQuantity, item.metafields.labels.single_unit_name_singular, item.metafields.labels.single_unit_name_plural);
							singleUnitQuantityBreakdown = singleUnitQuantity + ' ' + singleUnitQuantityLabel;
						}

						// Create the bulk unit quantity breakdown if possible
						if(item.metafields.labels.bulk_unit_name_singular) {
							bulkUnitQuantityLabel = slate.utils.pluralize(item.quantity, item.metafields.labels.bulk_unit_name_singular, item.metafields.labels.bulk_unit_name_plural);
							bulkUnitQuantityBreakdown = item.quantity + ' ' + bulkUnitQuantityLabel;
						}

						if(bulkUnitQuantityBreakdown || singleUnitQuantityBreakdown) {
							item.quantity_breakdown = '';
							// 2 Cases
							if(bulkUnitQuantityBreakdown) {
								item.quantity_breakdown += bulkUnitQuantityBreakdown;
							}
							// (24 Bottles)
							if(singleUnitQuantityBreakdown) {
								item.quantity_breakdown += ' (' + singleUnitQuantityBreakdown + ')';
							}
						}
					}

					// Check if the item is the free gift item
					if (item.variant_id === _this.giftProduct.variantId) {
						item.is_gift = true;
						item.is_gwp_hidden = true;
					}

					return item;
				});

				/**
				 *  You can also use this as an intermediate step to constructing the AJAX cart DOM
				 *  by returning an HTML string and using another function to do the DOM updating
				 *
				 *  return this.template(cart)
				 *
				 *  The code below isn't the most elegant way to update the cart but it works...
				 */

				$window.trigger(this.events.DESTROY);
				this.$container.empty().append( this.template(cart) );
				$window.trigger(this.events.RENDER);
				$window.trigger(this.events.UPDATE);

				this.updateCartCount(cart);
			},

			/**
			 * Update the cart badge + count here
			 *
			 * @param {Object} cart - JSON representation of the cart.
			 */
			updateCartCount: function(cart) {

				var item_count = parseInt(cart.item_count);
				var should_count_gift = this.giftProduct.variantId != null && this.giftProduct.showGiftProductInCart;

				if (cart.gwp_every_order_enabled && !should_count_gift && cart.items.length > 1) {
					this.$cartBadgeCount.html( item_count - 1 );
				} else {
					this.$cartBadgeCount.html( item_count );
				}

				if(cart.item_count) {
					this.$cartBadge.addClass(classes.cartBadgeHasItems);
				}
				else {
					this.$cartBadge.removeClass(classes.cartBadgeHasItems);
				}
			},

			/**
			 * Callback for changing the quantity of an item in the cart
			 *
			 * @param {event} e - Input change event
			 */
			onItemQuantitySelectChange: function(e) {
				var $select = $(e.currentTarget),
					attrs = this._getItemRowAttributes($select.get(0)),
					qty = this._validateQty( $select.val() ),
					_this = this;

				// We're deleting the item
				if(qty == 0) {
					attrs.$row.addClass('is-being-removed');
				}

				ShopifyAPI.changeItemQuantity(attrs.id, qty)
					.then(ShopifyAPI.getCart)
					.then(function(cart) {
						_this.buildCart.call(_this, cart);
						$window.trigger(slate.constants.cart.ajax.UPDATE, cart);
					});
			},

			onItemQuantityInputChange: function(e) {
				var $input = $(e.currentTarget),
					attrs = this._getItemRowAttributes($input.get(0)),
					qty = this._validateQty( $input.val() ),
					_this = this;

				// We're deleting the item
				if(qty == 0) {
					attrs.$row.addClass('is-being-removed');
				}

				ShopifyAPI.changeItemQuantity(attrs.id, qty, attrs.key)
					.then(ShopifyAPI.getCart)
					.then(function(cart) {
						_this.buildCart.call(_this, cart);
						$window.trigger(slate.constants.cart.ajax.UPDATE, cart);
					});
			},

			/**
			 * Remove the item from the cart.  Extract this into a separate method if there becomes more ways to delete an item
			 *
			 * @param {event} e - Click event
			 */
			onItemRemoveClick: function(e) {
				e.preventDefault();

				var attrs = this._getItemRowAttributes(e.target),
					_this = this;

				ShopifyAPI.changeItemQuantity(attrs.id, 0)
					.then(ShopifyAPI.getCart)
					.then(function(cart) {
						// Checks the final status of the cart to confirm if the gift should be present or not
						_this._checkCartStatus();
						$window.trigger(slate.constants.cart.ajax.UPDATE, cart);
					});
			},

			/**
			 * Increase the quantity of an item by 1
			 *
			 * @param {event} e - Click event
			 */
			onItemIncrementClick: function(e) {
				var _this = this;
				e.preventDefault();
				console.log('['+this.name+'] - onItemIncrementClick');

				var attrs = this._getItemRowAttributes(e.target);

				ShopifyAPI.changeItemQuantity(attrs.id, attrs.qty + 1).then(ShopifyAPI.getCart).then(function (data) {
					_this.buildCart.call(_this, data);
				});
			},

			/**
			 * Decrease the quantity of an item by 1
			 *
			 * @param {event} e - Click event
			 */
			onItemDecrementClick: function(e) {
				var _this = this;
				e.preventDefault();
				console.log('['+this.name+'] - onItemDecrementClick');

				var attrs = this._getItemRowAttributes(e.target);
				var newQty = (attrs.qty < 1 ? 0 : attrs.qty - 1);

				ShopifyAPI.changeItemQuantity(attrs.id, newQty).then(ShopifyAPI.getCart).then(function (data) {
					this.buildCart.bind(_this, data);
				});
			},

			/**
			 * Click the 'ajaxCart - trigger' selector
			 *
			 * @param {event} e - Click event
			 */
			onTriggerClick: function(e) {
				e.preventDefault();
				this.toggleVisibility();
			},

			/**
			 * Click the 'ajaxCart - close' selector
			 *
			 * @param {event} e - Click event
			 */
			onCloseClick: function(e) {
				e.preventDefault();
				console.log('['+this.name+'] - onCloseClick');

				// Do any cleanup before closing the cart
				this.close();
			},

			/**
			 * Opens / closes the cart depending on state
			 *
			 */
			toggleVisibility: function() {
				return this.stateIsOpen ? this.close() : this.open();
			},

			/**
			 * Check the open / closed state of the cart
			 *
			 * @return {bool}
			 */
			isOpen: function() {
				return this.stateIsOpen;
			},

			/**
			 * Returns true is the cart is closed.
			 *
			 * @return {bool}
			 */
			isClosed: function() {
				return !this.stateIsOpen;
			},

			/**
			 * Code for opening the cart
			 */
			open: function() {
				if(this.stateIsOpen) return;
				this.stateIsOpen = true;

				$body.addClass(classes.bodyCartOpen).css({
					paddingRight: scrollBarWidth
				});

				this.$el.addClass(classes.cartOpen);
				this.addBackdrop();
			},

			/**
			 * Code for closing the cart
			 */
			close: function() {
				if(!this.stateIsOpen) return;
				this.stateIsOpen = false;

				this.$el.removeClass(classes.cartOpen);
				this.removeBackdrop(function() {
					$body.removeClass(classes.bodyCartOpen).css({
						paddingRight: 0
					});
				});
			}
		});

		return AjaxCart;
	})();

})(jQuery, Handlebars, slate);









/**
 * AjaxCart section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 *
 * @param {string} container - selector for the section container DOM element
 */
function AjaxCart(container) {
	this.$container = $(container);

	this.name = 'ajaxCart';
	this.namespace = '.'+this.name;

	this.ajaxCart = new slate.AjaxCart();

	this.ajaxCart.init();

	var _this = this;

	$('.cart-popup-open').on('click', function() {
		_this.ajaxCart.open();
	});

}

AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

	/**
	 * Theme Editor section events below
	 */
	onSelect: function() {
		this.ajaxCart.open();
	},

	onDeselect: function() {
		this.ajaxCart.close();
	},

	onShow: function() {

	},

	onLoad: function() {

	},

	onUnload: function() {

	}
});

new AjaxCart('.shopify-section-ajax-cart');



$('.search-link').click(function() {
  $(".mobile-search").addClass("open");
  return false;
});
$('.close-search').click(function() {
  $(".mobile-search").removeClass("open");
  return false;
});





















































